module.exports = __webpack_public_path__ + "static/media/Participant Information Statement - My mental wellbeing.8846b924.txt";